export const classes = {
  wrapper: 'flex items-center',
  icon: 'text-2xl text-taupe-2 dark:text-mauve-2',
  activeIcon: 'text-brand-accent dark:text-brand-accent-dark',
  divider: 'mx-2',
  deleteButton:
    'text-taupe-2 hover:text-red-3 transition-colors dark:text-mauve-2 dark:hover:text-red-2',
  deleteIcon: 'text-inherit',
};
